import React, { useState } from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';

import WebinarIcon from '../../common/icons/WebinarIcon';

import { getCourseColor } from '../../../utils/course-utils';

const CourseSection = props => {
  const [isOpen, setIsOpen] = useState(false);

  const toggleIsOpen = () => {
    setIsOpen(!isOpen);
  };

  return (
    <div className="course-section">
      <div className="course-section-header" onClick={toggleIsOpen}>
        <div className="is-flex align-items-center justify-content-between">
          <div>
            <div className="is-flex align-items-center">
              <p className="course-section-num">SECTION {props.index}</p>
              <div className="ml-15px" style={{ marginTop: '2px' }}>
                <WebinarIcon color={getCourseColor(props.type)} />
              </div>
              <p className={classnames('course-section-webinar ml-10px', props.colorClassNames)}>
                {props.section.webinars.length} webinars
              </p>
            </div>
            <p className="course-section-name mt-15px">{props.section.name}</p>
          </div>
          <div>
            <img src="img/icons/caret-down.svg" />
          </div>
        </div>
      </div>
      {isOpen && (
        <div className="course-content">
          <ol>
            {props.section.webinars.map((webinar, webinarIndex) => (
              <li key={webinarIndex}>
                <span className="ml-15px">{webinar.name}</span>
                <ul className="course-content-ul">
                  {webinar.paragraphs.map((paragraph, paragraphIndex) => (
                    <li key={paragraphIndex}>{paragraph}</li>
                  ))}
                </ul>
              </li>
            ))}
          </ol>
        </div>
      )}
    </div>
  );
};

CourseSection.propTypes = {
  index: PropTypes.number.isRequired,
  type: PropTypes.number.isRequired,
  colorClassNames: PropTypes.string.isRequired,
  section: PropTypes.shape({
    name: PropTypes.string.isRequired,
    webinars: PropTypes.arrayOf(
      PropTypes.shape({
        name: PropTypes.string.isRequired,
        paragraphs: PropTypes.arrayOf(PropTypes.string).isRequired,
      }),
    ).isRequired,
  }).isRequired,
};

export default CourseSection;
